module.exports = __webpack_public_path__ + "static/img/loading.a20585dd.gif";